import * as React from 'react';
import * as style from './style.css';
import { FloorsPanelItem } from '../FloorsPanelItem';
import { IconChevronLeft12, IconChevronRight12, RoundButton } from '@cian/ui-kit';
import { useFloorPanel } from './hooks/useFloorPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FloorsPanel = function FloorsPanel(_ref) {
  var floorNumber = _ref.floorNumber,
    floors = _ref.floors,
    onFloorChange = _ref.onFloorChange;
  var _useFloorPanel = useFloorPanel(floors),
    hasPrevFloors = _useFloorPanel.hasPrevFloors,
    hasNextFloors = _useFloorPanel.hasNextFloors,
    onPrevButtonClick = _useFloorPanel.onPrevButtonClick,
    onNextButtonClick = _useFloorPanel.onNextButtonClick,
    panelRef = _useFloorPanel.panelRef;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [hasPrevFloors && /*#__PURE__*/_jsx("div", {
      className: style['page-control-prev'],
      children: /*#__PURE__*/_jsx(RoundButton, {
        theme: "fill_light",
        size: "XS",
        title: "\u041D\u0430\u0437\u0430\u0434",
        icon: /*#__PURE__*/_jsx(IconChevronLeft12, {}),
        onClick: onPrevButtonClick
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['floors-container'],
      children: /*#__PURE__*/_jsx("div", {
        className: style['floors'],
        ref: panelRef,
        children: floors.map(function (floor) {
          return /*#__PURE__*/_jsx(FloorsPanelItem, {
            floor: floor,
            onFloorChange: onFloorChange,
            floorNumber: floorNumber
          }, floor.number);
        })
      })
    }), hasNextFloors && /*#__PURE__*/_jsx("div", {
      className: style['page-control-next'],
      children: /*#__PURE__*/_jsx(RoundButton, {
        theme: "fill_light",
        size: "XS",
        title: "\u0414\u0430\u043B\u0435\u0435",
        icon: /*#__PURE__*/_jsx(IconChevronRight12, {}),
        onClick: onNextButtonClick
      })
    })]
  });
};